import { render } from "./editProvider.vue?vue&type=template&id=cb81df7c&scoped=true&ts=true"
import script from "./editProvider.vue?vue&type=script&lang=ts"
export * from "./editProvider.vue?vue&type=script&lang=ts"

import "./editProvider.vue?vue&type=style&index=0&id=cb81df7c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb81df7c"]])

export default __exports__